import { OutboundsUnallocatedType } from '@/services/outbound/outboundUnallocated/types'

// TODO: [SCOPE B] 대체 예정
export const UNALLOCATED_STATUS: SelectOption<OutboundsUnallocatedType>[] = [
  { label: '품절취소', value: '품절취소' },
  { label: '출고지연', value: '출고지연' },
  { label: '수집취소', value: '수집취소' },
]

// 임시값: 요청자 회신 전 잠정 상한이다. BE `OrdersRequest` 상한과 맞춰야 한다.
export const UNALLOCATED_SEARCH_MAX_INPUT_SIZE = 1000

// 시작일을 뺀 일수 차다. 시작일을 포함하면 31일까지 조회한다.
export const UNALLOCATED_SEARCH_MAX_DATE_RANGE = 30
